import { Input } from 'antd';
import React, { useEffect, useState } from 'react';
import Modal from '@mui/material/Modal';

import { useSettingsContext } from '@providers/settings-provider';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useDebounce } from '@hooks';
import cls from './ReportsModal.module.css';

const { Search } = Input;

const REPORTS_SHOW_DELAY = 600;
export const reportsList = {
  'Credits': 'Credits',
  'Credits graph': 'Credits graph',
  'Current Pipeline': 'Current Pipeline',
  'allocation-report': 'Credit Allocation Goals Tracker',
  'allocation-revenue-goals': 'Credit Allocation And Revenue Goals',
  'revenue-goals-tracker': 'Verqor Revenue Goals Tracker',
  'investor-reports-progress': 'Investor Reports - Progress',
  'active-pipeline-report': 'Active Pipeline',
  'Admin Login Counter': 'Admin Login Counter',
  'Pending Tickets': 'Pending Tickets',
  'Calls': 'Overdue Calls',
  'renewal-metrics-report': 'Renewal Metrics',
  'New Completed Files': 'New Completed Files',
  'New Documents Uploaded': 'New Documents Uploaded',
  'par-credits': 'Delayed Records',
  'Verqor\'s reach to women': 'Verqor\'s reach to women',
  'Registrations - gender': 'Registrations - gender',
  'Clients - gender': 'Clients - gender',
  'Contact Us entries': 'Contact Us entries',
  'visitors-report': 'Visitors / Effective registrations rate Graph',
  'new-registrations': 'New Registrations',
  'register-credit-progress': 'Registrations / Completed File / Apply - Rates',
  'user-crops': 'User Crops by Category',
  'credit-crops': 'Financed Crops by Category',
  'user-crops-by-crop': 'User crops by Crop',
  'credit-crops-by-crop': 'Financed crops',
  'financial-ranking': 'Financial Institution Ranking',
  'users-channel': 'Users Channel',
  'signed-credits-channel': 'Signed Credits Channel',
  'sales-performance': 'Sales Performance',
  'growth-on-sales': 'Sales\' Growth and Average Credit Amount',
  'top-buyers-ranking': 'Top Buyers - Ranking',
  'bdm-performance': 'BDM Performance',
};
export type ReportType = keyof typeof reportsList;

export const ReportsModal = () => {
  const {
    reportsOpened, setReportsOpened, admin, refreshAdmin, updateAdmin,
  } = useSettingsContext();
  const [reports, setReports] = useState<ReportType[]>(admin?.reports || []);
  const [search, setSearch] = useState('');
  const [labels, setLabels] = useState<any[]>([]);
  const debouncedReports = useDebounce((admin?.reports || []).join(''), REPORTS_SHOW_DELAY);

  useEffect(() => {
    reportsOpened && refreshAdmin();
  }, [reportsOpened]);

  useEffect(() => {
    setReports(admin?.reports || []);
  }, [debouncedReports]);

  const toggleColumn = async (reportKey: ReportType) => {
    const nextReports = reports.includes(reportKey)
      ? reports.filter(report => report !== reportKey)
      : reports.concat([reportKey]);
    setReports(nextReports);
    await updateAdmin({ reports: nextReports });
  };

  const onModalClose = (): void => {
    setReportsOpened(false);
    setSearch('');
  };

  useEffect(() => {
    const columns = Object.entries(reportsList).sort((a, b) => {
      const labelA = a[1] ?? '';
      const labelB = b[1] ?? '';
      return labelA.localeCompare(labelB);
    }).filter(i => ((i[1] === undefined) || (i[1].toLowerCase()
      .includes(search.toLowerCase().trim()))));
    setLabels(columns);
  }, [search]);

  return (
    <div className={cls.box}>
      <Modal
        open={reportsOpened}
        onClose={onModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className={cls.modal}
      >
        <Box className={cls.modal_wrap}>
          <div className={cls.modalTitle}>
            Reports
            <Search
              placeholder="input field name"
              onChange={(e) => setSearch(e.target.value)}
              className={cls.search}
            />
          </div>
          <FormGroup className={cls.columns} row>
            {labels.map(([reportKey, reportTitle]) => {
              const handleChange = () => toggleColumn(reportKey as ReportType);
              return (
                <FormControlLabel
                  key={reportKey}
                  className="checkbox"
                  control={
                    <Checkbox
                      color="secondary"
                      checked={reports.includes(reportKey as ReportType)}
                      onChange={handleChange}
                      inputProps={{ 'aria-label': 'controlled' }}
                    />
                  }
                  label={reportTitle}
                />
              );
            })}
          </FormGroup>
          <Button
            onClick={onModalClose}
            className={cls.saveBtn}
            type="submit"
            color="warning"
            variant="contained"
            size="large"
          >Apply</Button>
        </Box>
      </Modal>
    </div>
  );
};
